import request from 'crm/utils/request'
import api from 'crm/common/api/customer-fissions'

export async function fissionInfo() {
    return request(api.fissionInfo.url)
}

export async function fissionChannel(payload = {}) {
    return request(api.fissionChannel.url, {
        method: api.fissionChannel.type,
        body: payload.body,
    })
}

export async function fissionWelcomeMessage(payload = {}) {
    return request(api.fissionWelcomeMessage.url, {
        method: api.fissionWelcomeMessage.type,
        body: payload.body,
    })
}
